import React from 'react';
import { Field } from 'react-final-form';
import { Form as ToolkitForm } from '@contently/toolkit';
const { Label, Input, ErrorWrapper } = ToolkitForm;
import styled from '@emotion/styled';

const PaddedInputs = styled('div')`
  min-height: 75px;
`;

const InputField = (props) => {
  const { name, required, label, autoFocus, validate, formData } = props;

  const RenderInput = ({ input, meta }) => {
    return (
      <PaddedInputs>
        <Label required={required}>{label}</Label>
        <ErrorWrapper touched={meta.touched} error={meta.error}>
          <Input {...input} autoFocus={autoFocus}></Input>
        </ErrorWrapper>
      </PaddedInputs>
    );
  };

  return (
    <Field name={name} render={RenderInput} validate={validate} initialValue={formData[name]} />
  );
};

export default InputField;



// WEBPACK FOOTER //
// ./app/javascript/client/editor-ui/prompts/InputField.jsx